import { DrawerButton, DrawerIcon } from '@/components/chat/DrawerComponents';
import {
  mkLoginBtnTrackAttrs,
  mkLogoutBtnTrackAttrs,
} from '@/analytics/props/threadBar';
import { useAuth0 } from '@/auth/Auth0Client';

import { ListItemText, Tooltip } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';

export const LoginButton = ({
  displayIconOnly = false,
}: {
  displayIconOnly?: boolean;
}) => {
  const { login, logout, isAuthenticated } = useAuth0();
  const loginButton = (
    <DrawerButton
      {...(isAuthenticated ? mkLogoutBtnTrackAttrs() : mkLoginBtnTrackAttrs())}
      $isOpen={!displayIconOnly}
      onClick={isAuthenticated ? logout : login}
    >
      <DrawerIcon $isOpen={!displayIconOnly}>
        {isAuthenticated ? (
          <LogoutIcon
            sx={(theme) => ({ fill: theme.palette.secondary.main })}
          />
        ) : (
          <LoginIcon sx={(theme) => ({ fill: theme.palette.secondary.main })} />
        )}
      </DrawerIcon>
      <ListItemText
        primary={isAuthenticated ? 'Log Out' : 'Log In'}
        sx={{ opacity: displayIconOnly ? 0 : 1 }}
      />
    </DrawerButton>
  );

  return displayIconOnly ? (
    <Tooltip
      title={isAuthenticated ? 'Log Out' : 'Log In'}
      arrow
      placement="right"
    >
      {loginButton}
    </Tooltip>
  ) : (
    loginButton
  );
};
